import React, { Component } from 'react';
import setCookie from '../../cookie/setCookie';

const divStyle = {
  WebkitTransition: 'all', // note the capital 'W' here
  msTransition: 'all' ,// 'ms' is the only lowercase vendor prefix
  float:'right',
  marginRight:'10px'
};

class OpenDouble extends Component{

  render() {
      return (
        <div id="div_laypopup">
            <img src={require('../../img/event_popup_point.png').default} width="100%" height="100%" alt=""/>
            <div style={divStyle}>
              <input id="check" type="checkbox" name="openDouble" onClick={this.closeWin}/>
              <label for="check"><span>하루동안 이 창을 열지 않음</span></label>
            </div>
        </div>
      )
    }

     closeWin = ()=>{
      // setCookie( "openDouble", "done" , 0.000116);
      setCookie( "openDouble", "done" , 1);
      window.close();
    }

}//end class


export default OpenDouble;
